export default "__VITE_PUBLIC_ASSET__f56586a5__"